
// Utility Colors

export const purple = '#424CA0';
export const orange = '#EF7B45';
export const white = '#FFFFFF';
export const grey = "#808080";
export const greyTwo = "#373737"
